<template>
  <v-flex d-block xs12>
    <v-card>
      <v-card-title>
        <h3 style="display: inline-block;">Service groups</h3>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <table class="v-table theme--light">
          <thead>
          <tr>
            <th class="column text-xs-left">Title</th>
            <th class="column text-xs-left">Color scheme</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <service-group-item v-for="serviceGroup in items"
                               v-bind:key="serviceGroup.id"
                               v-bind:item="serviceGroup">
          </service-group-item>
          <tr v-if="items.length === 0">
            <td colspan="3" class="text-sm-center">No available service groups</td>
          </tr>
          </tbody>
        </table>
        <v-flex d-block xs6>
          <service-group-creation-form
            :visible="createServiceGroupFormVisible"
            @close="handleCreationFormCloseEvent"></service-group-creation-form>
        </v-flex>
        <v-btn color="success"
               v-if="!createServiceGroupFormVisible"
               @click="handleClickCreateServiceGroupButton">Create</v-btn>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import ServiceGroupItem from './ServiceGroupItem'
import ServiceGroupCreationForm from './ServiceGroupCreationForm'

export default {
  name: 'service-groups',
  components: {
    ServiceGroupItem,
    ServiceGroupCreationForm
  },
  props: {
    items: {
      type: Array
    }
  },
  data () {
    return {
      createServiceGroupFormVisible: false
    }
  },
  computed: {
  },
  methods: {
    handleClickCreateServiceGroupButton () {
      this.createServiceGroupFormVisible = !this.createServiceGroupFormVisible
    },
    handleCreationFormCloseEvent () {
      this.createServiceGroupFormVisible = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/ServiceGroups.vue